import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { updateSlackID } from '../query';
// Custom hook for the mutation
export function useMutateSlackID(): UseMutationResult<
  void,
  Error,
  { userId: string; slackID: string }
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      userId,
      slackID,
    }: {
      userId: string;
      slackID: string;
    }) => {
      await updateSlackID(userId, slackID);
    },
    onSuccess: async () => {
      toast.success('Slack connected successfully');
      await queryClient.invalidateQueries({
        queryKey: ['slackConnectionStatus'],
      });
    },
    onError: () => {
      toast.error('Failed to connect Slack, Please try again');
    },
  });
}
